/**
 * 倒计时提示, 2019.10.12
 * author: michael
 */
var Toast = (function(){
    var time = 10;
    var rootEl = document.body;
    var toastEl = null;
    var timeEl = null;

    var lastTime = 0;

    var __PROTOTYPE__ = {
        isShow: false,
        createDom: function(msg){
            var message = msg;
            
            toastEl = document.createElement('div');
            toastEl.id = "toast-time";
            toastEl.style.display = 'none';
            toastEl.style.position = 'fixed';
            toastEl.style.top = '1em';
            toastEl.style.left = '20%';
            toastEl.style.width = '60%';
            toastEl.style.zIndex = '999999';
            toastEl.style.padding = '.7em .5em';
            toastEl.style.fontSize = '16px';
            toastEl.style.backgroundColor = 'rgba(0, 0, 0, .7)';
            toastEl.style.color = '#fff';
            toastEl.style.borderRadius = '5px';
            toastEl.style.textAlign = 'center';

            toastEl.innerHTML = 'Please try<span id="toast-seconds" style="padding: 0 3px;"></span>seconds later';
            
            rootEl.appendChild(toastEl);

            timeEl = document.getElementById('toast-seconds');
        },

        ownTimer: null,
        timerFn: function(){
            __PROTOTYPE__.ownTimer = setTimeout(function(){
                time --;
                timeEl.innerHTML = time;
                if(time <= 0){
                    __PROTOTYPE__.clear();
                    return;
                }
                __PROTOTYPE__.timerFn();
            }, 1000);
        },

        show: function(t){
            var currentTime = +new Date();
            if(__PROTOTYPE__.isShow){
                return;
            }

            if(currentTime - lastTime <= time * 1000){
                __PROTOTYPE__.isShow = true;
                toastEl.style.display = "block";

                time = Math.floor((10 * 1000 - (currentTime - lastTime)) / 1000) + 1;
                timeEl.innerHTML = time;
                __PROTOTYPE__.timerFn();
            }else{
                __PROTOTYPE__.clear();
                lastTime = currentTime;
            }
        },

        clear: function(){
            clearTimeout(__PROTOTYPE__.ownTimer);

            __PROTOTYPE__.isShow = false;
            toastEl.style.display = 'none';
            time = 10;
            lastTime = 0;
            timeEl.innerHTML = time;
        },
    
        init: function(msg){
            __PROTOTYPE__.createDom(msg);
        }
    }

    var __TOAST__ = function(msg){
        var hasExist = document.getElementById('toast-time') || null;
        if(hasExist){
            this.show();
        }else{
            this.init(msg);
        }
    }

    __TOAST__.prototype = __PROTOTYPE__;

    return __TOAST__;
})(window);

export default Toast;


// WEBPACK FOOTER //
// ./src/assets/js/toast-time.js